import React, { Component } from "react";
import { connect } from "react-redux";
import Dialog from "material-ui/Dialog";
import { Field, reduxForm } from 'redux-form';

import { GetUserDocumentMasterFolderById, saveUserDocumentMasterFolder } from '../../../patients/actions/PatientActions';
import { renderCheckBox, renderTextField } from '../../../../components/reduxFields';
import { CancelButton, SubmitButtonModal, SubmitButtonModalDisabled } from '../../../../components/buttons';
import SmallLoader from '../../../../img/small-loader.gif';
//import validate from './validateMasterFolder';
import { checkFieldExistence, clearFieldErrorArray } from '../../../../modules/AppConfig/actions';
import { MODULE } from './../../constants/ApiConstants';
import { displayCustomError } from '../../../../../src/actions/utilAction';

const validate = (values) => {
  const errors = {};  
  
  if (!values.folderName) {
    errors.folderName = 'Please enter master folder name';
  }
  return errors;
};

class MasterFoldersModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      open: true,
      masterFolderId: props.masterFolderId,
      userId: props.userId,
      userTypeName: props.userTypeName,
    };
  }

  componentWillMount() {
    if (this.state.masterFolderId) {
      this.props.GetUserDocumentMasterFolderById(this.state.masterFolderId);
    }
  }

  handleOpen = () => {
    this.setState({ open: true });
  };

  handleClose = () => {
    if (this.state.open) {
      this.props.clearFieldErrorArray();
      this.setState({ open: false });
      this.props.closeDialog();
    }
  };

  componentWillReceiveProps(nextProps) {
    let self = this;
    document.onkeydown = function(evt) {
      evt = evt || window.event;
      if (evt.keyCode === 27) {
        self.handleClose();
      }
    };

  }

  renderLoading() {
    return (
      <div>
        {this.props.loading ? (
          <div className="full_loader top0">
            <div className="small-loader">
              <img src={SmallLoader} alt="" />
            </div>
          </div>
        ) : null}
      </div>
    );
  }

  onSubmitHandler(formProps) {
    // if ((this.props.fieldError && this.props.fieldError.length) || (this.props.fieldErrorLoading)) { // Avoid Submit if field error checking
    //   return null;
    // }
    let postData = {
      "id": this.props.masterFolderId || 0,
      "folderName": formProps.folderName,
      "userId" : this.state.userId,
      "userTypeName" : this.state.userTypeName,
      "isActive":  formProps.isActive || false
    }
    this.props.clearFieldErrorArray();
    //console.log('postData............',postData)
    this.props.saveUserDocumentMasterFolder(postData);
    this.setState({ open: false });
    this.props.closeDialog();
  }

  checkFieldDataExistence = (input, value, labelName) => {
    if (value.length > 0) {
      let postData = {
        'labelName': labelName,
        'tableName': `${MODULE}_${input.target.name}`.toUpperCase(),
        'value': value,
        'colmnName': input.target.name.toUpperCase(),
        'id': this.state.masterFolderId || 0,
      };
      this.props.checkFieldExistence(postData);
    }
  };

  handleNewRequest = (input, selectedRecord) => {
    input.onChange(selectedRecord.value);
  };

  render() {
    const { handleSubmit } = this.props;
    let submitButton = this.props.loading ?
    <SubmitButtonModalDisabled label="Loading" /> :
    <SubmitButtonModal label="Save" onSubmit={handleSubmit(this.onSubmitHandler.bind(this))} />;
    const actions = [
        <CancelButton className="mr-15" onTouchTap={this.handleClose} />,
        submitButton,
      ];
    return (
      <Dialog
        className="custom_modal"
        title={
          this.state.masterFolderId
            ? "Edit Master Folder"
            : "Add Master Folder"
        }
        modal={false}
        open={this.state.open}
        actions={actions}
        autoScrollBodyContent={true}
      >
        {this.renderLoading()}
        <div className="row">
          <div className="col-sm-12">
            <form
              className="readmin-form custom_form"
              onSubmit={handleSubmit(this.onSubmitHandler.bind(this))}
            >
              <div className="row">
                <div className="col-sm-12 require">
                  <Field
                    autoFocus={true}
                    name="folderName"
                    type="text"          
                    // onChange={(input, value) => this.checkFieldDataExistence(input, value, 'folder name')}
                    // customError={displayCustomError('FOLDERNAME', this.props.fieldError)}        
                    maxLength="250"
                    label="Master Folder Name"
                    // normalize={isValidNameWithSpace}
                    component={renderTextField}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-sm-3">
                  <Field
                    className="mt20 mb0"
                    name="isActive"
                    label="Is Active"
                    component={renderCheckBox}
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
      </Dialog>
    );
  }
}

MasterFoldersModal = reduxForm({
    form: 'MasterFoldersModalForm',
    validate,
    enableReinitialize: true,
})(MasterFoldersModal);


function mapStateToProps(state, ownProps) { 

  let initialValueData = {
    isActive: true,
  };
  if (ownProps.masterFolderId && state.patient.userDocumentMasterFolderDetails) {
    initialValueData = state.patient.userDocumentMasterFolderDetails.data || null;
  } 

  return {
    loading: state.patient.loading,
    fieldError: state.appConfig.fieldError,
    fieldErrorLoading: state.appConfig.fieldErrorLoading,
    initialValues: initialValueData,
  }
}

export default connect(mapStateToProps,{GetUserDocumentMasterFolderById, checkFieldExistence, clearFieldErrorArray, saveUserDocumentMasterFolder})(MasterFoldersModal);



// WEBPACK FOOTER //
// ./src/modules/users/component/staffDocuments/masterFolders_Modal.js